const UserEnvironment = () => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle
			cx="13"
			cy="13.1875"
			r="12"
			stroke="#1A0638"
			strokeWidth="1.28571"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.45833 19.3568H16.5417M10.875 16.5234V19.3568M15.125 16.5234V19.3568M7.33333 8.02344H18.6667C19.0579 8.02344 19.375 8.34057 19.375 8.73177V15.8151C19.375 16.2063 19.0579 16.5234 18.6667 16.5234H7.33333C6.94213 16.5234 6.625 16.2063 6.625 15.8151V8.73177C6.625 8.34057 6.94213 8.02344 7.33333 8.02344Z"
			stroke="#1A0638"
			strokeWidth="1.15909"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default UserEnvironment;
